import {HelpOutline} from '@mui/icons-material';
import {MenuItem, Typography} from '@mui/material';
import styles from '../../Header.module.scss';
import {useState} from 'react';
import {TechnicalSupportModal} from './TechnicalSupportModal';
import {useTranslation} from 'react-i18next';

export const TechnicalSupport = () => {
    const {t} = useTranslation('administration');
    const [openModal, setOpenModal] = useState(false);

    const onClose = () => {
        setOpenModal(false);
    };

    return (
        <>
            <MenuItem
                onClick={() => {
                    setOpenModal(true);
                }}
                className={styles.menuItem}
            >
                <HelpOutline sx={{mr: 1}} />
                <Typography>{t('technicalSupport.title')}</Typography>
            </MenuItem>
            {openModal && <TechnicalSupportModal onClose={onClose} />}
        </>
    );
};
